export const cloneDeep = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value))
}

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

/**
 * 拡張子から動画かどうかを判定する
 */
export const isVideo = (url: string): boolean => {
  url = url.substring(url.lastIndexOf("."))
  url = url.toUpperCase()

  const RegObj = /\.(mp4$)|(mov$)|(avi$)|(fiv$)|(wmv$)/i
  return RegObj.test(url)
}
